<template>
  <v-card-text class="pa-3 pa-sm-6 flashcards-tab">
    <!-- Barra de Ações Superior -->
    <v-row class="mb-4">
      <v-col cols="12">
        <v-card elevation="2" rounded="lg">
          <v-card-text class="pa-3">
            <v-row align="center" dense>
              <v-col cols="12" sm="6" md="3">
                <v-btn
                    block
                    color="primary"
                    @click="dialogTemas = true"
                    elevation="0"
                >
                  <v-icon left>mdi-folder-multiple</v-icon>
                  Gerenciar Temas
                </v-btn>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-btn
                    block
                    color="success"
                    @click="dialogFlashcard = true"
                    elevation="0"
                >
                  <v-icon left>mdi-card-plus</v-icon>
                  Criar Flashcard
                </v-btn>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-btn
                    block
                    color="info"
                    @click="dialogImportar = true"
                    elevation="0"
                >
                  <v-icon left>mdi-file-upload</v-icon>
                  Importar CSV
                </v-btn>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-btn
                    block
                    color="orange darken-1"
                    dark
                    @click="carregarFlashcardsRevisao"
                    :loading="carregandoRevisao"
                    elevation="0"
                >
                  <v-icon left>mdi-refresh</v-icon>
                  Atualizar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Área Principal de Revisão -->
    <v-row>
      <v-col cols="12">
        <v-card elevation="4" rounded="lg">
          <v-card-title class="orange darken-1 white--text pb-2 responsive-card-title">
            <v-icon left color="white" :size="$vuetify.breakpoint.xs ? 22 : 28">mdi-brain</v-icon>
            <span class="text-body-1 text-sm-h6">Revisão de Flashcards</span>
            <v-spacer></v-spacer>
            <v-chip color="white" text-color="orange darken-1" :small="$vuetify.breakpoint.xs">
              {{ flashcardsRevisao.length }} flashcards
            </v-chip>
          </v-card-title>

          <!-- Filtro por Tema -->
          <v-card-text class="pb-0 pt-3 px-3 px-sm-4">
            <v-select
                v-model="filtroTemaRevisao"
                :items="[{id: null, nome: 'Todos os temas'}, ...temas]"
                item-text="nome"
                item-value="id"
                label="Filtrar por Tema"
                outlined
                dense
                clearable
                prepend-inner-icon="mdi-filter"
                @change="carregarFlashcardsRevisao"
            ></v-select>
          </v-card-text>

          <v-card-text class="pa-3 pa-sm-4">
            <v-progress-linear
                v-if="carregandoRevisao"
                indeterminate
                color="orange"
            ></v-progress-linear>

            <!-- Modo Estudo: Exibir um flashcard por vez -->
            <div v-else-if="flashcardsRevisao.length > 0 && !modoLista">
              <div class="text-center mb-4">
                <v-chip color="primary" dark :large="$vuetify.breakpoint.smAndUp">
                  <v-icon left>mdi-counter</v-icon>
                  {{ indiceAtual + 1 }} / {{ flashcardsRevisao.length }}
                </v-chip>
              </div>

              <v-card outlined class="mb-4" elevation="3">
                <v-card-title class="justify-center primary white--text py-3 py-sm-4 responsive-card-title">
                  <v-icon left color="white">mdi-help-circle</v-icon>
                  <span class="text-h6">Pergunta</span>
                </v-card-title>
                <v-card-text class="flashcard-face text-center">
                  <div class="flashcard-text mb-3">{{ flashcardAtual.pergunta }}</div>
                  <v-chip color="blue" dark>
                    <v-icon left small>mdi-folder</v-icon>
                    {{ flashcardAtual.tema }}
                  </v-chip>
                </v-card-text>
              </v-card>

              <!-- Botão para revelar resposta -->
              <v-btn
                  v-if="!respostaRevelada"
                  block
                  :x-large="$vuetify.breakpoint.smAndUp"
                  :large="$vuetify.breakpoint.xs"
                  color="secondary"
                  @click="revelarResposta"
                  class="mb-4"
                  elevation="2"
              >
                <v-icon left>mdi-eye</v-icon>
                Revelar Resposta
              </v-btn>

              <!-- Resposta revelada -->
              <div v-else>
                <v-card outlined class="mb-4" elevation="3" color="success lighten-5">
                  <v-card-title class="justify-center success white--text py-3 py-sm-4 responsive-card-title">
                    <v-icon left color="white">mdi-check-circle</v-icon>
                    <span class="text-h6">Resposta</span>
                  </v-card-title>
                  <v-card-text class="flashcard-face text-center">
                    <div class="flashcard-text">{{ flashcardAtual.resposta }}</div>
                  </v-card-text>
                </v-card>

                <!-- Informações do Flashcard -->
                <v-card outlined class="mb-4" color="grey lighten-4">
                  <v-card-text class="pa-4">
                    <v-progress-linear
                      v-if="carregandoRevisaoInfo"
                      indeterminate
                      color="primary"
                      class="mb-3"
                    ></v-progress-linear>
                    <v-row v-else-if="revisaoInfo" dense class="text-center">
                      <v-col cols="12" sm="4">
                        <div class="text-caption grey--text text-uppercase">Nível</div>
                        <div class="text-h5 font-weight-bold primary--text">{{ revisaoInfo.nivel }}</div>
                      </v-col>
                      <v-col cols="12" sm="4">
                        <div class="text-caption grey--text text-uppercase">Repetições</div>
                        <div class="text-h5 font-weight-bold primary--text">{{ revisaoInfo.repeticoes }}</div>
                      </v-col>
                      <v-col cols="12" sm="4">
                        <div class="text-caption grey--text text-uppercase">Próxima</div>
                        <div class="text-body-1 font-weight-medium">{{ formatarData(revisaoInfo.proximaRevisao) }}</div>
                      </v-col>
                    </v-row>
                    <div v-else class="text-center text-caption grey--text">
                      Carregando informações...
                    </div>
                  </v-card-text>
                </v-card>

                <!-- Botão de Explicação com IA -->
                <v-btn
                    block
                    large
                    color="purple darken-1"
                    dark
                    @click="explicarComIA"
                    :loading="carregandoExplicacao"
                    :disabled="carregandoAvaliacao"
                    class="mb-4"
                    elevation="2"
                >
                  <v-icon left>{{ flashcardAtual.explicacao ? 'mdi-text-box-search' : 'mdi-brain' }}</v-icon>
                  {{ flashcardAtual.explicacao ? 'Ver Explicação' : 'Explicar com IA' }}
                </v-btn>

                <!-- Botões de Avaliação -->
                <div class="text-subtitle-1 text-center mb-3 font-weight-medium">
                  Como você avalia sua lembrança?
                </div>
                <v-row dense class="mb-4">
                  <v-col cols="6" sm="3">
                    <v-btn
                        block
                        large
                        color="error"
                        @click="avaliarFlashcard(0)"
                        :loading="carregandoAvaliacao"
                        elevation="2"
                    >
                      <div class="text-center">
                        <v-icon size="32">mdi-close-circle</v-icon>
                        <div class="text-caption mt-1">Não lembrei</div>
                      </div>
                    </v-btn>
                  </v-col>
                  <v-col cols="6" sm="3">
                    <v-btn
                        block
                        large
                        color="warning"
                        @click="avaliarFlashcard(1)"
                        :loading="carregandoAvaliacao"
                        elevation="2"
                    >
                      <div class="text-center">
                        <v-icon size="32">mdi-alert-circle</v-icon>
                        <div class="text-caption mt-1">Difícil</div>
                      </div>
                    </v-btn>
                  </v-col>
                  <v-col cols="6" sm="3">
                    <v-btn
                        block
                        large
                        color="info"
                        @click="avaliarFlashcard(2)"
                        :loading="carregandoAvaliacao"
                        elevation="2"
                    >
                      <div class="text-center">
                        <v-icon size="32">mdi-check-circle</v-icon>
                        <div class="text-caption mt-1">Bom</div>
                      </div>
                    </v-btn>
                  </v-col>
                  <v-col cols="6" sm="3">
                    <v-btn
                        block
                        large
                        color="success"
                        @click="avaliarFlashcard(3)"
                        :loading="carregandoAvaliacao"
                        elevation="2"
                    >
                      <div class="text-center">
                        <v-icon size="32">mdi-check-all</v-icon>
                        <div class="text-caption mt-1">Fácil</div>
                      </div>
                    </v-btn>
                  </v-col>
                </v-row>
              </div>

              <!-- Navegação -->
              <v-row dense class="mb-3">
                <v-col cols="12" sm="6">
                  <v-btn
                      block
                      large
                      outlined
                      color="primary"
                      @click="flashcardAnterior"
                      :disabled="indiceAtual === 0"
                  >
                    <v-icon left>mdi-chevron-left</v-icon>
                    Anterior
                  </v-btn>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-btn
                      block
                      large
                      outlined
                      color="primary"
                      @click="proximoFlashcard"
                      :disabled="indiceAtual === flashcardsRevisao.length - 1"
                  >
                    Próximo
                    <v-icon right>mdi-chevron-right</v-icon>
                  </v-btn>
                </v-col>
              </v-row>

              <v-divider class="my-3"></v-divider>

              <v-btn
                  block
                  text
                  color="primary"
                  @click="modoLista = true"
              >
                <v-icon left>mdi-view-list</v-icon>
                Ver todos em lista
              </v-btn>
            </div>

            <!-- Modo Lista: Exibir todos os flashcards -->
            <div v-else-if="flashcardsRevisao.length > 0 && modoLista">
              <v-btn
                  block
                  large
                  color="primary"
                  class="mb-4"
                  @click="modoLista = false; indiceAtual = 0; respostaRevelada = false;"
              >
                <v-icon left>mdi-cards</v-icon>
                Modo Estudo
              </v-btn>

              <!-- Controles de Ordenação -->
              <v-card outlined class="mb-4">
                <v-card-text class="pa-3">
                  <div class="text-subtitle-2 font-weight-medium mb-2">
                    <v-icon small left>mdi-sort</v-icon>
                    Ordenar por:
                  </div>
                  <v-chip-group>
                    <v-chip
                        small
                        :color="ordenacao.campo === 'nivel' ? 'primary' : 'grey lighten-1'"
                        :outlined="ordenacao.campo !== 'nivel'"
                        @click="ordenarPor('nivel')"
                    >
                      <v-icon small left>{{ getOrdenacaoIcon('nivel') }}</v-icon>
                      Nível
                    </v-chip>
                    <v-chip
                        small
                        :color="ordenacao.campo === 'repeticoes' ? 'primary' : 'grey lighten-1'"
                        :outlined="ordenacao.campo !== 'repeticoes'"
                        @click="ordenarPor('repeticoes')"
                    >
                      <v-icon small left>{{ getOrdenacaoIcon('repeticoes') }}</v-icon>
                      Repetições
                    </v-chip>
                    <v-chip
                        small
                        :color="ordenacao.campo === 'proximaRevisao' ? 'primary' : 'grey lighten-1'"
                        :outlined="ordenacao.campo !== 'proximaRevisao'"
                        @click="ordenarPor('proximaRevisao')"
                    >
                      <v-icon small left>{{ getOrdenacaoIcon('proximaRevisao') }}</v-icon>
                      Próxima Revisão
                    </v-chip>
                    <v-chip
                        small
                        :color="ordenacao.campo === 'ultimaRevisao' ? 'primary' : 'grey lighten-1'"
                        :outlined="ordenacao.campo !== 'ultimaRevisao'"
                        @click="ordenarPor('ultimaRevisao')"
                    >
                      <v-icon small left>{{ getOrdenacaoIcon('ultimaRevisao') }}</v-icon>
                      Última Revisão
                    </v-chip>
                  </v-chip-group>
                </v-card-text>
              </v-card>

              <v-list two-line>
                <v-list-item
                    v-for="(flashcard, index) in flashcardsOrdenados"
                    :key="flashcard.flashcardId"
                    class="mb-3 elevation-1 rounded-lg flashcard-list-item"
                >
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium mb-2">
                      <v-icon small left color="primary">mdi-help-circle</v-icon>
                      {{ flashcard.pergunta }}
                    </v-list-item-title>

                    <!-- Resposta com botão de revelar -->
                    <v-list-item-subtitle class="mb-2">
                      <v-expand-transition>
                        <div v-show="respostasReveladas[flashcard.flashcardId]">
                          <v-icon small left color="success">mdi-check-circle</v-icon>
                          {{ flashcard.resposta }}
                        </div>
                      </v-expand-transition>
                      <v-btn
                          v-if="!respostasReveladas[flashcard.flashcardId]"
                          x-small
                          outlined
                          color="primary"
                          @click="toggleRespostaLista(flashcard.flashcardId)"
                      >
                        <v-icon small left>mdi-eye</v-icon>
                        Revelar Resposta
                      </v-btn>
                    </v-list-item-subtitle>
                    <div class="d-flex align-center flex-wrap">
                      <v-chip x-small class="mr-1 mb-1" color="blue" dark>
                        {{ flashcard.tema }}
                      </v-chip>
                      <v-chip x-small class="mr-1 mb-1">
                        Nível: {{ flashcard.nivel }}
                      </v-chip>
                      <v-chip x-small class="mr-1 mb-1">
                        Repetições: {{ flashcard.repeticoes }}
                      </v-chip>
                      <v-chip x-small class="mr-1 mb-1">
                        Próxima: {{ formatarData(flashcard.proximaRevisao) }}
                      </v-chip>
                      <v-chip x-small class="mb-1">
                        Ultima: {{ formatarData(flashcard.ultimaRevisao) }}
                      </v-chip>
                    </div>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn
                        color="primary"
                        @click="iniciarEstudoFlashcard(index)"
                    >
                      <v-icon left>mdi-school</v-icon>
                      Estudar
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </div>

            <v-alert v-else type="info" text prominent>
              <v-row align="center">
                <v-col class="grow">
                  Nenhum flashcard disponível para revisão no momento.
                </v-col>
                <v-col class="shrink">
                  <v-btn color="primary" @click="carregarFlashcardsRevisao">
                    <v-icon left>mdi-refresh</v-icon>
                    Recarregar
                  </v-btn>
                </v-col>
              </v-row>
            </v-alert>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Modal: Gerenciar Temas -->
    <v-dialog
        v-model="dialogTemas"
        max-width="600px"
        :fullscreen="$vuetify.breakpoint.xs"
        persistent
        scrollable
        class="responsive-dialog"
    >
      <v-card>
        <v-card-title class="primary white--text responsive-dialog-title">
          <v-icon left color="white">mdi-folder-multiple</v-icon>
          Gerenciar Temas
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialogTemas = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-3 pa-sm-6">
          <!-- Criar Novo Tema -->
          <v-form ref="formTema" v-model="formTemaValido" @submit.prevent="criarTema">
            <v-text-field
                v-model="novoTema"
                label="Nome do Tema"
                outlined
                dense
                prepend-inner-icon="mdi-folder-plus"
                :rules="[v => !!v || 'Nome é obrigatório']"
                class="mb-2"
            >
              <template v-slot:append-outer>
                <v-btn
                    color="primary"
                    @click="criarTema"
                    :loading="carregandoTema"
                    :disabled="!novoTema"
                >
                  <v-icon left>mdi-plus</v-icon>
                  Criar
                </v-btn>
              </template>
            </v-text-field>
          </v-form>

          <v-divider class="my-4"></v-divider>

          <!-- Lista de Temas -->
          <div class="text-subtitle-1 font-weight-medium mb-3">Temas Cadastrados</div>
          <v-list v-if="temas.length > 0" dense>
            <v-list-item
                v-for="tema in temas"
                :key="tema.id"
                @click="temaSelecionado = tema.id"
                :class="{'primary lighten-5': temaSelecionado === tema.id}"
                class="rounded-lg mb-2 flashcard-theme-item"
            >
              <v-list-item-icon>
                <v-icon :color="temaSelecionado === tema.id ? 'primary' : 'grey'">
                  mdi-folder
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="font-weight-medium">{{ tema.nome }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-chip x-small color="primary" outlined>
                  ID: {{ tema.id }}
                </v-chip>
              </v-list-item-action>
              <v-list-item-action>
                <v-btn
                    icon
                    @click.stop="editarTema(tema)"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
          <v-alert v-else type="info" text dense>
            Nenhum tema cadastrado ainda.
          </v-alert>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Modal: Criar Flashcard -->
    <v-dialog
        v-model="dialogFlashcard"
        max-width="600px"
        :fullscreen="$vuetify.breakpoint.xs"
        persistent
        scrollable
        class="responsive-dialog"
    >
      <v-card>
        <v-card-title class="success white--text responsive-dialog-title">
          <v-icon left color="white">mdi-card-plus</v-icon>
          Criar Flashcard
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialogFlashcard = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-3 pa-sm-6">
          <v-form ref="formFlashcard" v-model="formFlashcardValido">
            <v-select
                v-model="novoFlashcard.temaId"
                :items="temas"
                item-text="nome"
                item-value="id"
                label="Selecione o Tema"
                outlined
                dense
                prepend-inner-icon="mdi-folder"
                :rules="[v => !!v || 'Tema é obrigatório']"
                class="mb-3"
            ></v-select>

            <v-textarea
                v-model="novoFlashcard.pergunta"
                label="Pergunta"
                outlined
                rows="3"
                prepend-inner-icon="mdi-help-circle"
                :rules="[v => !!v || 'Pergunta é obrigatória']"
                class="mb-3"
            ></v-textarea>

            <v-textarea
                v-model="novoFlashcard.resposta"
                label="Resposta"
                outlined
                rows="3"
                prepend-inner-icon="mdi-check-circle"
                :rules="[v => !!v || 'Resposta é obrigatória']"
                class="mb-3"
            ></v-textarea>

            <v-btn
                block
                large
                color="success"
                @click="criarFlashcard"
                :loading="carregandoFlashcard"
                :disabled="!formFlashcardValido"
            >
              <v-icon left>mdi-plus</v-icon>
              Criar Flashcard
            </v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Modal: Editar Tema -->
    <v-dialog
        v-model="dialogEditarTema"
        max-width="500px"
        :fullscreen="$vuetify.breakpoint.xs"
        persistent
        scrollable
        class="responsive-dialog"
    >
      <v-card>
        <v-card-title class="warning white--text responsive-dialog-title">
          <v-icon left color="white">mdi-pencil</v-icon>
          Editar Tema
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialogEditarTema = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-3 pa-sm-6">
          <v-form ref="formEditarTema" v-model="formEditarTemaValido">
            <v-text-field
                v-model="nomeTemaEditado"
                label="Nome do Tema"
                outlined
                dense
                prepend-inner-icon="mdi-pencil"
                :rules="[v => !!v || 'Nome é obrigatório']"
                class="mb-4"
            ></v-text-field>

            <v-btn
                block
                large
                color="warning"
                @click="salvarEdicaoTema"
                :loading="carregandoEdicaoTema"
                :disabled="!formEditarTemaValido"
            >
              <v-icon left>mdi-content-save</v-icon>
              Salvar Alterações
            </v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Modal: Importar CSV -->
    <v-dialog
        v-model="dialogImportar"
        max-width="600px"
        :fullscreen="$vuetify.breakpoint.xs"
        persistent
        scrollable
        class="responsive-dialog"
    >
      <v-card>
        <v-card-title class="info white--text responsive-dialog-title">
          <v-icon left color="white">mdi-file-upload</v-icon>
          Importar CSV
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialogImportar = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-3 pa-sm-6">
          <v-alert type="info" text dense class="mb-4">
            <div class="text-body-2">
              <strong>Formato do CSV:</strong> pergunta,resposta<br>
              Use aspas duplas se houver vírgulas no texto.
            </div>
          </v-alert>

          <v-select
              v-model="importacao.temaId"
              :items="temas"
              item-text="nome"
              item-value="id"
              label="Selecione o Tema para Importação"
              outlined
              dense
              prepend-inner-icon="mdi-folder"
              :rules="[v => !!v || 'Tema é obrigatório']"
              class="mb-3"
          ></v-select>

          <v-file-input
              v-model="importacao.arquivo"
              label="Selecione o arquivo CSV"
              outlined
              dense
              accept=".csv"
              prepend-icon="mdi-paperclip"
              :rules="[v => !!v || 'Arquivo é obrigatório']"
              class="mb-3"
          ></v-file-input>

          <v-btn
              block
              large
              color="info"
              @click="importarCSV"
              :loading="carregandoImportacao"
              :disabled="!importacao.temaId || !importacao.arquivo"
          >
            <v-icon left>mdi-upload</v-icon>
            Importar Flashcards
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Modal: Explicação com IA -->
    <v-dialog
        v-model="dialogExplicacao"
        max-width="700px"
        :fullscreen="$vuetify.breakpoint.xs"
        persistent
        scrollable
        class="responsive-dialog"
    >
      <v-card>
        <v-card-title class="purple darken-1 white--text responsive-dialog-title">
          <v-icon left color="white">mdi-brain</v-icon>
          Explicação com IA
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialogExplicacao = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-3 pa-sm-6">
          <v-alert v-if="!flashcardAtual.explicacao" type="info" text dense class="mb-4">
            <div class="text-body-2">
              <v-icon small left>mdi-information</v-icon>
              <strong>Explicação gerada por Inteligência Artificial</strong>
            </div>
          </v-alert>

          <!-- Pergunta do Flashcard -->
          <v-card outlined class="mb-4" color="primary lighten-5">
            <v-card-text class="pa-4">
              <div class="text-caption grey--text text-uppercase mb-1">Pergunta</div>
              <div class="text-body-1 font-weight-medium">{{ flashcardAtual.pergunta }}</div>
            </v-card-text>
          </v-card>

          <!-- Resposta do Flashcard -->
          <v-card outlined class="mb-4" color="success lighten-5">
            <v-card-text class="pa-4">
              <div class="text-caption grey--text text-uppercase mb-1">Resposta</div>
              <div class="text-body-1 font-weight-medium">{{ flashcardAtual.resposta }}</div>
            </v-card-text>
          </v-card>

          <!-- Explicação da IA -->
          <v-card outlined class="mb-2" color="purple lighten-5">
            <v-card-text class="pa-4">
              <div class="text-caption grey--text text-uppercase mb-2">
                <v-icon small left color="purple darken-1">mdi-robot</v-icon>
                Explicação Detalhada
              </div>
              <div v-if="explicacaoIA" class="text-body-1" style="white-space: pre-line;">{{ explicacaoIA }}</div>
              <div v-else class="text-center grey--text">
                <v-progress-circular indeterminate color="purple"></v-progress-circular>
                <div class="mt-2">Gerando explicação...</div>
              </div>
            </v-card-text>
          </v-card>
        </v-card-text>
        <v-card-actions class="pa-3 pa-sm-4 responsive-actions">
          <v-spacer></v-spacer>
          <v-btn
              large
              color="purple darken-1"
              dark
              @click="dialogExplicacao = false"
          >
            <v-icon left>mdi-check</v-icon>
            Entendi
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card-text>
</template>

<script>
import flashcardService from '@/services/flashcardService';

export default {
  name: 'FlashcardsTab',

  data() {
    return {
      // Modais
      dialogTemas: false,
      dialogFlashcard: false,
      dialogImportar: false,

      // Temas
      temas: [],
      novoTema: '',
      temaSelecionado: null,
      carregandoTema: false,
      formTemaValido: false,
      dialogEditarTema: false,
      temaEditando: null,
      nomeTemaEditado: '',
      carregandoEdicaoTema: false,

      // Flashcards
      novoFlashcard: {
        temaId: null,
        pergunta: '',
        resposta: ''
      },
      carregandoFlashcard: false,
      formFlashcardValido: false,

      // Importação
      importacao: {
        temaId: null,
        arquivo: null
      },
      carregandoImportacao: false,

      // Revisão
      flashcardsRevisao: [],
      filtroTemaRevisao: null,
      carregandoRevisao: false,
      indiceAtual: 0,
      respostaRevelada: false,
      carregandoAvaliacao: false,
      modoLista: false,
      revisaoInfo: null,
      carregandoRevisaoInfo: false,
      formEditarTemaValido: false,
      ordenacao: {
        campo: null,
        direcao: 'asc'
      },
      respostasReveladas: {}, // Armazena quais respostas estão reveladas no modo lista

      // Explicação de IA
      explicacaoIA: null,
      carregandoExplicacao: false,
      dialogExplicacao: false,
    };
  },

  computed: {
    flashcardAtual() {
      return this.flashcardsRevisao[this.indiceAtual] || {};
    },

    flashcardsOrdenados() {
      if (!this.ordenacao.campo) {
        return this.flashcardsRevisao;
      }

      const ordenados = [...this.flashcardsRevisao];
      const campo = this.ordenacao.campo;
      const direcao = this.ordenacao.direcao === 'asc' ? 1 : -1;

      ordenados.sort((a, b) => {
        let valorA = a[campo];
        let valorB = b[campo];

        // Tratamento especial para datas
        if (campo === 'proximaRevisao' || campo === 'ultimaRevisao') {
          valorA = valorA ? new Date(valorA).getTime() : 0;
          valorB = valorB ? new Date(valorB).getTime() : 0;
        }

        if (valorA < valorB) return -1 * direcao;
        if (valorA > valorB) return 1 * direcao;
        return 0;
      });

      return ordenados;
    }
  },

  mounted() {
    this.carregarTemas();
    this.carregarFlashcardsRevisao();
  },

  methods: {
    async carregarTemas() {
      try {
        const response = await flashcardService.listarTemas();
        this.temas = response.data;
      } catch (error) {
        console.error('Erro ao carregar temas:', error);
        this.$toast.error('Erro ao carregar temas de flashcards');
      }
    },

    async criarTema() {
      if (!this.novoTema) return;

      this.carregandoTema = true;
      try {
        await flashcardService.criarTema(this.novoTema);
        this.$toast.success('Tema criado com sucesso!');
        this.novoTema = '';
        await this.carregarTemas();
      } catch (error) {
        console.error('Erro ao criar tema:', error);
        const mensagem = error.response?.data?.message || 'Erro ao criar tema';
        this.$toast.error(mensagem);
      } finally {
        this.carregandoTema = false;
      }
    },

    async criarFlashcard() {
      if (!this.$refs.formFlashcard.validate()) return;

      this.carregandoFlashcard = true;
      try {
        await flashcardService.criarFlashcard(this.novoFlashcard);
        this.$toast.success('Flashcard criado com sucesso!');
        this.novoFlashcard = {
          temaId: null,
          pergunta: '',
          resposta: ''
        };
        this.$refs.formFlashcard.reset();
        this.dialogFlashcard = false;
        await this.carregarFlashcardsRevisao();
      } catch (error) {
        console.error('Erro ao criar flashcard:', error);
        const mensagem = error.response?.data?.message || 'Erro ao criar flashcard';
        this.$toast.error(mensagem);
      } finally {
        this.carregandoFlashcard = false;
      }
    },

    async importarCSV() {
      if (!this.importacao.temaId || !this.importacao.arquivo) {
        this.$toast.warning('Selecione o tema e o arquivo CSV');
        return;
      }

      this.carregandoImportacao = true;
      try {
        await flashcardService.importarCSV(this.importacao.temaId, this.importacao.arquivo);
        this.$toast.success('Flashcards importados com sucesso!');
        this.importacao = {
          temaId: null,
          arquivo: null
        };
        this.dialogImportar = false;
        await this.carregarFlashcardsRevisao();
      } catch (error) {
        console.error('Erro ao importar flashcards:', error);
        const mensagem = error.response?.data?.message || 'Erro ao importar flashcards';
        this.$toast.error(mensagem);
      } finally {
        this.carregandoImportacao = false;
      }
    },

    async carregarFlashcardsRevisao() {
      this.carregandoRevisao = true;
      try {
        const response = await flashcardService.buscarFlashcardsRevisao(this.filtroTemaRevisao);
        this.flashcardsRevisao = response.data;
        this.indiceAtual = 0;
        this.respostaRevelada = false;
      } catch (error) {
        console.error('Erro ao carregar flashcards para revisão:', error);
        this.$toast.error('Erro ao carregar flashcards para revisão');
      } finally {
        this.carregandoRevisao = false;
      }
    },

    async revelarResposta() {
      this.respostaRevelada = true;
      await this.carregarRevisaoInfo();
    },

    async carregarRevisaoInfo() {
      if (!this.flashcardAtual || !this.flashcardAtual.flashcardId) {
        return;
      }

      this.carregandoRevisaoInfo = true;
      try {
        const response = await flashcardService.buscarRevisaoInfo(this.flashcardAtual.flashcardId);
        this.revisaoInfo = response.data;
      } catch (error) {
        console.error('Erro ao carregar informações de revisão:', error);
        // Não mostra toast de erro para não atrapalhar a experiência
        this.revisaoInfo = null;
      } finally {
        this.carregandoRevisaoInfo = false;
      }
    },

    async avaliarFlashcard(nivel) {
      if (!this.flashcardAtual || !this.flashcardAtual.flashcardId) {
        this.$toast.error('Flashcard inválido');
        return;
      }

      this.carregandoAvaliacao = true;
      try {
        await flashcardService.avaliarFlashcard(this.flashcardAtual.flashcardId, nivel);

        const niveis = ['Não lembrou', 'Difícil', 'Bom', 'Fácil'];
        this.$toast.success(`Avaliado como: ${niveis[nivel]}`);

        this.flashcardsRevisao.splice(this.indiceAtual, 1);

        if (this.indiceAtual >= this.flashcardsRevisao.length && this.flashcardsRevisao.length > 0) {
          this.indiceAtual = this.flashcardsRevisao.length - 1;
        }

        this.respostaRevelada = false;

        if (this.flashcardsRevisao.length === 0) {
          this.$toast.info('Parabéns! Você revisou todos os flashcards disponíveis!');
          await this.carregarFlashcardsRevisao();
        }
      } catch (error) {
        console.error('Erro ao avaliar flashcard:', error);
        const mensagem = error.response?.data?.message || 'Erro ao avaliar flashcard';
        this.$toast.error(mensagem);
      } finally {
        this.carregandoAvaliacao = false;
      }
    },

    proximoFlashcard() {
      if (this.indiceAtual < this.flashcardsRevisao.length - 1) {
        this.indiceAtual++;
        this.respostaRevelada = false;
        this.revisaoInfo = null;
      }
    },

    flashcardAnterior() {
      if (this.indiceAtual > 0) {
        this.indiceAtual--;
        this.respostaRevelada = false;
        this.revisaoInfo = null;
      }
    },

    iniciarEstudoFlashcard(index) {
      // Encontra o flashcard na lista ordenada e obtém o índice na lista original
      const flashcardOrdenado = this.flashcardsOrdenados[index];
      const indiceOriginal = this.flashcardsRevisao.findIndex(
        f => f.flashcardId === flashcardOrdenado.flashcardId
      );

      this.modoLista = false;
      this.indiceAtual = indiceOriginal >= 0 ? indiceOriginal : 0;
      this.respostaRevelada = false;
      this.revisaoInfo = null;
    },

    formatarData(data) {
      if (!data) return '-';

      // Se a data está no formato YYYY-MM-DD (sem hora), trata como data local
      if (typeof data === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(data)) {
        const [ano, mes, dia] = data.split('-');
        return `${dia}/${mes}/${ano}`;
      }

      // Caso contrário, usa o Date normal
      const date = new Date(data);
      return date.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      });
    },

    editarTema(tema) {
      this.temaEditando = tema;
      this.nomeTemaEditado = tema.nome;
      this.dialogEditarTema = true;
    },

    async salvarEdicaoTema() {
      if (!this.$refs.formEditarTema.validate()) return;

      this.carregandoEdicaoTema = true;
      try {
        await flashcardService.editarTema(this.temaEditando.id, this.nomeTemaEditado);
        this.$toast.success('Tema atualizado com sucesso!');
        this.dialogEditarTema = false;
        this.temaEditando = null;
        this.nomeTemaEditado = '';
        await this.carregarTemas();
      } catch (error) {
        console.error('Erro ao editar tema:', error);
        const mensagem = error.response?.data?.message || 'Erro ao editar tema';
        this.$toast.error(mensagem);
      } finally {
        this.carregandoEdicaoTema = false;
      }
    },

    ordenarPor(campo) {
      if (this.ordenacao.campo === campo) {
        // Se já está ordenando pelo mesmo campo, inverte a direção
        this.ordenacao.direcao = this.ordenacao.direcao === 'asc' ? 'desc' : 'asc';
      } else {
        // Se é um campo diferente, define como ascendente
        this.ordenacao.campo = campo;
        this.ordenacao.direcao = 'asc';
      }
    },

    getOrdenacaoIcon(campo) {
      if (this.ordenacao.campo !== campo) {
        return 'mdi-sort';
      }
      return this.ordenacao.direcao === 'asc' ? 'mdi-sort-ascending' : 'mdi-sort-descending';
    },

    toggleRespostaLista(flashcardId) {
      this.$set(this.respostasReveladas, flashcardId, !this.respostasReveladas[flashcardId]);
    },

    async explicarComIA() {
      if (!this.flashcardAtual || !this.flashcardAtual.flashcardId) {
        this.$toast.error('Flashcard inválido');
        return;
      }

      // Se já existe explicação, apenas mostra o modal
      if (this.flashcardAtual.explicacao) {
        this.explicacaoIA = this.flashcardAtual.explicacao;
        this.dialogExplicacao = true;
        return;
      }

      // Se não existe, gera com IA
      this.carregandoExplicacao = true;
      this.explicacaoIA = null;

      try {
        const response = await flashcardService.explicarFlashcard(this.flashcardAtual.flashcardId);
        this.explicacaoIA = response.data;
        this.dialogExplicacao = true;
      } catch (error) {
        console.error('Erro ao gerar explicação com IA:', error);
        const mensagem = error.response?.data?.message || 'Erro ao gerar explicação com IA';
        this.$toast.error(mensagem);
      } finally {
        this.carregandoExplicacao = false;
      }
    },
  },
};
</script>

<style scoped>
.rounded-lg {
  border-radius: 12px;
}

.flashcard-face {
  padding: 32px;
}

.flashcard-text {
  font-size: clamp(18px, 5vw, 24px);
  line-height: 1.35;
  overflow-wrap: anywhere;
  white-space: pre-line;
}

.responsive-actions {
  flex-wrap: wrap;
  gap: 8px;
}

.responsive-actions .v-btn {
  margin-left: 0 !important;
}

@media (max-width: 599px) {
  .flashcards-tab {
    overflow-x: hidden;
  }

  .flashcard-face {
    padding: 20px 12px;
  }

  .responsive-card-title,
  .responsive-dialog-title {
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
    line-height: 1.25;
    word-break: break-word;
  }

  .responsive-dialog-title .spacer {
    display: none;
  }

  .flashcard-list-item,
  .flashcard-theme-item {
    align-items: flex-start;
    flex-wrap: wrap;
    padding: 8px !important;
  }

  .flashcard-list-item ::v-deep .v-list-item__action,
  .flashcard-theme-item ::v-deep .v-list-item__action {
    flex: 1 1 100%;
    margin: 8px 0 0 0 !important;
    align-items: stretch;
  }

  .flashcard-list-item ::v-deep .v-list-item__action .v-btn,
  .flashcard-theme-item ::v-deep .v-list-item__action .v-btn {
    width: 100%;
  }

  .flashcard-theme-item ::v-deep .v-list-item__icon {
    margin-right: 12px !important;
  }

  .responsive-actions {
    justify-content: stretch;
  }

  .responsive-actions .v-btn {
    flex: 1 1 100%;
  }

  .responsive-actions .spacer {
    display: none;
  }

  ::v-deep .v-dialog {
    margin: 8px !important;
    max-height: calc(100% - 16px) !important;
  }

  ::v-deep .v-dialog--fullscreen {
    margin: 0 !important;
    max-height: 100% !important;
  }

  ::v-deep .v-dialog .v-card__text {
    overflow-y: auto;
  }

  ::v-deep .v-input__append-outer {
    display: block;
    margin: 8px 0 0 0;
    width: 100%;
  }

  ::v-deep .v-input__append-outer .v-btn {
    width: 100%;
  }

  ::v-deep .v-chip-group .v-slide-group__content {
    flex-wrap: wrap;
  }

  ::v-deep .v-list-item__content {
    min-width: 0;
  }

  ::v-deep .v-list-item__title,
  ::v-deep .v-list-item__subtitle {
    overflow: visible;
    text-overflow: clip;
    white-space: normal;
    word-break: break-word;
  }

  ::v-deep .v-chip {
    max-width: 100%;
  }

  ::v-deep .v-chip .v-chip__content {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
